import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Addresses',
    id: 'global.account.link.my_addresses'
  },
  noAddresses: {
    defaultMessage: `You don't have any saved addresses, you can add one from the address book page by clicking on link below.`,
    id: 'msp.account.overview.no_address'
  }
})

export default translations
